export default __webpack_public_path__ + "static/media/R5C_8161.ba6cac17.jpg";